import { FieldValues, Path, useFormContext } from 'react-hook-form';
import { DefaultFieldProps } from '../types';
import { RHFFieldWrapperProps } from '../shared';

export const useFormatRHFFieldProps = <V, T extends string, P extends Record<string, any>>({
  test,
  name,
  help,
  note,
  title,
  required,
  optional,
  className,
  hideError,
  iconMargin,
  labelLoader,
  customError,
  dynamicError,
  setValueOptions = { shouldDirty: true, shouldValidate: true },
  ...restProps
}: P & Omit<DefaultFieldProps<T, V>, 'onChange'>) => {
  type FormValues = FieldValues & { [name: string]: V };

  const formContext = useFormContext<FormValues>();

  const { watch, register } = formContext;
  const fieldValue = watch(name satisfies Path<FormValues>) as V;
  const fieldRegister = register(name satisfies Path<FormValues>);
  const fieldWrapperProps: Partial<RHFFieldWrapperProps<T, V>> = {
    name,
    help,
    note,
    title,
    required,
    optional,
    className,
    hideError,
    iconMargin,
    customError,
    labelLoader,
    dynamicError
  };

  return {
    fieldValue,
    formContext,
    fieldRegister,
    setValueOptions,
    fieldWrapperProps,
    fieldProps: { name, test, value: fieldValue, ...restProps }
  };
};
